"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var temp = function FlagTwoTone(primaryColor, secondaryColor) {
    return {
        name: 'flag',
        theme: 'twotone',
        nameWithTheme: 'flag-twotone',
        tag: 'svg',
        attrs: {
            xmlns: 'http://www.w3.org/2000/svg',
            class: 'icon',
            viewBox: '0 0 1024 1024'
        },
        children: [
            {
                tag: 'path',
                attrs: { fill: secondaryColor, d: 'M184 232h368v336H184z' },
                children: []
            },
            {
                tag: 'path',
                attrs: {
                    fill: secondaryColor,
                    d: 'M624 632c0 4.4-3.6 8-8 8H504v73h336V377H624v255z'
                },
                children: []
            },
            {
                tag: 'path',
                attrs: {
                    d: 'M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32zM184 568V232h368v336H184zm656 145H504v-73h112c4.4 0 8-3.6 8-8V377h216v336z',
                    fill: primaryColor
                },
                children: []
            }
        ]
    };
};
temp.nameWithTheme = 'flag-twotone';
var FlagTwoTone = temp;
exports.default = FlagTwoTone;



//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/node_modules/@ant-design/icons/lib/twotone/FlagTwoTone.js
// module id = 1131
// module chunks = 0